import {client} from '@/stores/client.js'
import {useUserStore} from '@/stores/user.js';

export const getAuthenticatedRequest = () => {
  const userStore = useUserStore();
  return {
    'request': 1009,
    'client': client,
    'account': {
      'id': userStore.getUserId,
      'credential': userStore.getCredential
    }
  };
};
